import { cn } from "@/lib/utils";
interface AdminContentContainerProps {
  className?: string;
  children: React.ReactNode;
  bottomBar?: React.ReactNode | null;
  scrollContent?: boolean;
}

function AdminContentContainer({
  className,
  children,
  bottomBar = null,
}: AdminContentContainerProps) {
    return (
      <div
        className={cn(
          "flex flex-col overflow-hidden",
          className,
        )}
      >
        <div className="grow overflow-auto">{children}</div>
        {bottomBar}
      </div>
    );
}

export default AdminContentContainer;
